/*
 * @Author: your name
 * @Date: 2020-12-03 16:42:32
 * @LastEditTime: 2022-11-15 17:27:59
 * @LastEditors: pj
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\common\config.js
 */
const testEnv = 'fat';
const switchEnv = getEnv();
const Env = switchEnv.envname;
const PROTOCOL = switchEnv.protocol; //web协议
const API_HOST = switchEnv.apihost; //api hostname
const JOBCENTER_HOST = switchEnv.jobcenterhost;//jobcenter Hostname
const Branch_HOST = "branch.cnzhonglunnet.com"


///////////////////////////////////////////////////////////////////////////////////////////
function getEnv () {
    const envList = {
        'fdev': 'dev',
        'fsim': 'sim',
        'fsit': 'sit',
        'fuat': 'uat',
        'fpet': 'pet',
        'fpre': 'pre',
        'ffat': 'fat',
        'f': 'pro',

        'fpdev': 'dev',
        'fpsim': 'sim',
        'fpsit': 'sit',
        'fpuat': 'uat',
        'fppet': 'pet',
        'fppre': 'pre',
        'fpfat': 'fat',
        'fp': 'pro',
    }
    let apihost = "";
    let protocol = window.location.protocol;
    let jobcenterhost = window.location.protocol;
    let envname = ''
    apihost = window.location.host;
    //jobcenterhost = window.location.host.replace('f', 'jobv5')
    jobcenterhost = 'yxlws.yili.com/jobs';
    if (apihost.indexOf('localhost') != -1 || apihost.indexOf('192.168.11.33') != -1) {
        //  apihost = 'localhost:8080';
        // apihost = 'yapi.cnzhonglunnet.com/mock/855'
        // apihost = '192.168.9.45:8070/fp'
        let host_px = testEnv == 'pro' ? 'pri' : testEnv;
        apihost = 'f' + host_px + '.cnzhonglunnet.com';
        jobcenterhost = 'jobv5' + host_px + '.cnzhonglunnet.com';
        envname = testEnv
    }
    else {
        //服务器上
        if (apihost.split('.').length > 0) {
            let keyname = apihost.split('.')[0];
            envname = envList[keyname];
        }
        else {
            envname = ''
        }
    }
    return {
        envname,
        protocol,
        apihost,
        jobcenterhost
    }
}

///////////////////////////////////////////////////////////////////////////////////////////
const CONFIG = {
    Env,
    API_HOST,
    PAGE_SIZE: 10,
    OSS_LOCATION: 'http://192.168.1.63:9000/data/',
    ApiNatToHost: (apiUrl) => {
        return PROTOCOL + "//" + API_HOST + '/' + apiUrl
    },
    JobCenterHost: (apiUrl) => {
        return PROTOCOL + "//" + JOBCENTER_HOST + '/' + apiUrl
    },
    BranchHost: (apiUrl) => {
        return PROTOCOL + "//" + Branch_HOST + '' + apiUrl
    }
}

export default CONFIG
